import { Helmet } from 'react-helmet-async';

import { Content } from './components/Content';

export const AdminASOneSubscriptionsPage = () => {
  return (
    <>
      <Helmet>
        <title>Subscriptions - AutoScript Admin</title>
      </Helmet>

      <Content />
    </>
  );
};
